import { Bell, BellOff } from "lucide-react";

export function ContactNotifications({ off, onChange, disabled }: { off?: boolean; onChange?: (off: boolean) => void; disabled?: boolean }) {
  const label = off ? "Notifications off" : "Notifications on";
  const icon = off ? <BellOff size={16} aria-hidden="true" /> : <Bell size={16} aria-hidden="true" />;
  return onChange
    ? <button type="button" className="job-icon-button" aria-label={label} aria-pressed={!off} title={`${label} — click to ${off ? "enable" : "disable"}`} disabled={disabled} onClick={() => onChange(!off)}>{icon}</button>
    : <span className="job-contact-muted-icon" role="img" aria-label={label} title={label}>{icon}</span>;
}
